<template>
  <thead class="bg-gray-50">
    <tr>
      <th scope="col" class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
        Name
      </th>
      <th scope="col" class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
        SKU
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
      >
        Total Pcs
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right"
      >
        Total Sales
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
